module.exports = __webpack_public_path__ + "img/firefox.dec615d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/browsers/firefox.png
// module id = BjBr
// module chunks = 38 43